import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';

import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';

const Container = styled.div``;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BVIErrorsComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  render() {
    return (
      <Cell>
        <Container onClick={() => this.props.history.push(`/vehicles/${this.vehicle.id}`)}>
          <HBox vCenter left>
            <VehicleHeader vehicle={this.vehicle} />
          </HBox>
        </Container>
      </Cell>
    );
  }
}

BVIErrorsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //work: selectWorks([REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId + '_' + ownProps.cell.vehicle.id]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIErrors = compose(
  withConnect,
  withRouter,
)(BVIErrorsComp);
